import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-galleries',
  templateUrl: './galleries.component.html',
  styleUrls: ['./galleries.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleriesComponent implements OnInit {
  @Input() gallery = undefined;
  @Input() type: string = 'detail';
  @Input() removeMargins = false;
  @Output() showGallery = new EventEmitter();

  constructor(
    public paramSv: ParamServicesService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    const data = this.paramSv.emitImagesObs.subscribe((item) => {
      if (item === 'finish') {
        this.cdr.detectChanges();
        data.unsubscribe();
      }
    });
  }

  showMore() {
    this.showGallery.emit(this.gallery);
  }
}
